import { render, staticRenderFns } from "./GetMovieDescription.vue?vue&type=template&id=5e72fbc8&scoped=true&"
import script from "./GetMovieDescription.vue?vue&type=script&lang=js&"
export * from "./GetMovieDescription.vue?vue&type=script&lang=js&"
import style0 from "./GetMovieDescription.vue?vue&type=style&index=0&id=5e72fbc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72fbc8",
  null
  
)

export default component.exports